import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-action-button",
    styleUrls: ["./action-button.component.scss"],
    templateUrl: "./action-button.component.html",
    standalone: false
})
export class FUIActionButtonComponent extends FUIButtonComponent {

}
